export default "__VITE_ASSET__35B54Ls5__"